// DatePickerComponent.tsx
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface RHFDatePickerProps {
  name: string;
  label?: string;
  format?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  placeholder?: string;
}

export const RHFDatePicker: React.FC<RHFDatePickerProps> = React.memo(({
  name,
  label,
  format = "MM/dd/yyyy",
  disabled = false,
  fullWidth = true,
  size = 'medium',
  placeholder,
  ...other
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <div className="date-picker">
            <MUIDatePicker
              label={label}
              value={field.value}
              onChange={field.onChange}
              format={format}
              disabled={disabled}
              slotProps={{
                textField: {
                  fullWidth,
                  size,
                  sx: {
                    '& .MuiOutlinedInput-root': {
                      height: '40px',
                      borderRadius: '8px',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#C8CEE3 !important',
                        borderRadius: '8px',
                        borderWidth: '1px !important',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#C8CEE3 !important',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#C8CEE3 !important',
                        borderWidth: '1px !important',
                      },
                      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#FF0000 !important',
                      },
                    },
                  },
                  error: !!error,
                  helperText: error?.message || "",
                  placeholder,
                  ...other
                }
              }}
            />
          </div>
        </LocalizationProvider>
      )}
    />
  );
}); 